import { fetcher } from "helpers/fetcher";

import {
  TCreateBusinessEstablishmentReq,
  TCreateBusinessEstablishmentRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createBusinessEstablishment = async (
  payload?: TCreateBusinessEstablishmentReq
) => {
  return await fetcher<TCreateBusinessEstablishmentRes, any>(
    ENDPOINT.CORPORATION.CREATE_BUSINESS_ESTABLISHMENT,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.CREATE_BUSINESS_ESTABLISHMENT.version,
        [API_HEADER.CORP_ID]: payload?.idCorp,
      },
    }
  );
};

export const mutationCreateBusinessEstablishment = async (
  payload?: TCreateBusinessEstablishmentReq
) => {
  return (await createBusinessEstablishment(payload)).data;
};

mutationCreateBusinessEstablishment._key = (
  payload?: TCreateBusinessEstablishmentReq
) => [ENDPOINT.CORPORATION.CREATE_BUSINESS_ESTABLISHMENT.url, payload];
